import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetChargingSessionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterEmspBoChargingSessionListContext } from '../../emsp-bo-charging-session.context';
import { EmspBoChargingSessionListFilterFormStep1Controller } from '../emsp-bo-charging-session-list-filter-form-step-1/emsp-bo-charging-session-list-filter-form-step-1.controller';

export interface EmspBoChargingSessionListFilterFormFormControllerProps {
  onError: SubmitErrorHandler<GetChargingSessionsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetChargingSessionsPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoChargingSessionListFilterFormController = (
  props: EmspBoChargingSessionListFilterFormFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterEmspBoChargingSessionListContext();

  return (
    <MultiStepFormProvider<GetChargingSessionsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [],
          component: <EmspBoChargingSessionListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
